<template>
    <f7-page name="Submit">
        <f7-navbar
            :title-large="submission.type === 'story' ? 'Your story' : 'Got a question?'"
            large
            large-transparent
        >
            <f7-nav-left>
                <f7-link
                    back
                    icon="ion-ios-arrow-left"
                />
            </f7-nav-left>
            <f7-nav-title>
                {{ submission.type === 'story' ? 'Your story' : 'Got a question?' }}
            </f7-nav-title>
            <f7-nav-right>
                <f7-button
                    v-if="submission.type"
                    color="red"
                    rounded
                    large
                    style="padding: 0 10px"
                    @click="send"
                >SEND</f7-button>
            </f7-nav-right>
        </f7-navbar>

        <template v-if="submission.type === 'select'">
            <f7-block style="margin-top: 32px">
                What would you like to share with the community?<br><br>

                <div class="ansButtons ">
                    <f7-button
                        color="red"
                        fill
                        round
                        @click="submission.type = 'question';"
                    >A question</f7-button>
                    <f7-button
                        color="red"
                        fill
                        round
                        @click="submission.type = 'story';"
                    >A story</f7-button>
                </div>
            </f7-block>

        </template>
        <template v-if="submission.type === 'story'">

            <f7-block style="margin-top: 12px">What would you like to call your story? You can say something like “I realized at 34 that I wanted more from my sex life" or “I learned how to manage my PE with the help of one (very patient) lover.”</f7-block>
            <f7-list>
                <f7-list-input
                    type="text"
                    label="Story title"
                    placeholder="My great story"
                    @input="submission.title=$event.target.value"
                />

            </f7-list>
            <f7-block>
                You can either write your story or record yourself telling it.
                Either way, your entries are completely anonymous!
            </f7-block>
            <f7-row
                style="margin: -10px 0 0 0"
                class="ansButtons"
            >
                <f7-col>
                    <f7-button
                        :class="` ${mode === 'text' ? 'myAnswer': ''}`"
                        color="red"
                        fill
                        round
                        @click="setMode('text')"
                    >Write it</f7-button>
                </f7-col>
                <f7-col>
                    <f7-button
                        :class="`${mode === 'audio' ? 'myAnswer': ''}`"
                        color="red"
                        fill
                        round
                        @click="setMode('audio')"
                    >Say it</f7-button>
                </f7-col>
            </f7-row>

            <template v-if="mode === 'text'">
                <f7-list
                    inline-labels
                    no-hairlines-md
                >
                    <f7-list-input
                        type="textarea"
                        resizable
                        placeholder="Write your story here!"
                        style="min-height: 100px"
                        @input="submission.text=$event.target.value"
                    />

                </f7-list>
            </template>
            <template v-if="mode === 'audio'">
                <f7-block>
                    We’re all ears! (You get three takes to get it just right.)
                </f7-block>
                <recorder
                    :attempts="3"
                    :headers="{}"
                    :time="5"
                    :start-record="callback"
                    :stop-record="callback"
                    :start-upload="callback"
                    :successful-upload="callback"
                    :failed-upload="callback"
                    upload-url="YOUR_API_URL"
                />
            </template>

        </template>
        <template v-if="submission.type === 'question'">
            <div>
                <f7-block style="margin-top: 12px">Ask away! If your question is chosen it will be posted anonymously and answered by our team of experts and the Coral community.</f7-block>
                <f7-list
                    inline-labels
                    no-hairlines-md
                >
                    <f7-list-item>
                        <f7-input
                            type="textarea"
                            resizable
                            placeholder="I was wondering..."
                            style="min-height: 100px"
                            @input="submission.text=$event.target.value"
                        />
                    </f7-list-item>
                </f7-list>
            </div>
        </template>

    </f7-page>
</template>

<script>
import Recorder from '../components/recorder/recorder.vue';

export default {
    store: ['api', 'user', 'takeSelected'],
    components: {
        Recorder
    },
    data () {
        return {
            mode: '',
            submission: {
                title: '',
                text: '',
                type: '',
                courseId: 0,
            }
        };
    },
    computed: {},
    created: function () { },
    mounted: function () {
        if (this.$f7route.query.type) {
            this.submission.type = this.$f7route.query.type;
        } else {
            this.submission.type = 'select';
        }
        if (this.$f7route.query.courseId) {
            this.submission.courseId = this.$f7route.query.courseId;
        }
        if (this.submission.type !== 'select' && !this.user.username) {
            f7.views['main'].router.navigate('/username?view=main');
        }
    },
    methods: {
        setMode: function (mode) {
            if (this.mode === mode) return;
            this.mode = mode;
            this.takeSelected = false;
        },
        callback: function () { },
        send: function () {
            if (!this.user.username) {
                f7.views['main'].router.navigate('/username?view=main');
                return;
            }
            if (this.mode === 'audio' && this.submission.type === 'story' && !this.takeSelected) {
                return f7.dialog.alert('You must select a take first!');
            }
            if (this.submission.type === 'question' && this.submission.text.length < 10) {
                return f7.toast.create({
                    text: 'Question is too short!',
                    position: 'center',
                    closeTimeout: 2000,
                }).open();
            }
            this.$http.post(`${this.api}/submissions`, this.submission).then(
                response => {
                    this.$events.fire('trackEvent', `submit_${this.submission.type}`, 'submission', 0, '', {});
                    if (this.mode === 'audio' && this.submission.type === 'story') {
                        this.$events.fire('do-upload-story', response.body.id);
                    }
                    f7.dialog.alert('Thanks!');
                    this.takeSelected = false;
                    this.mode = '';
                    this.submission.title = '';
                    this.submission.text = '';
                    this.submission.type = '';
                    this.$f7.views['main'].router.back();
                    f7.preloader.hide();
                },
                response => {
                    f7.preloader.hide();
                    f7.dialog.alert(response.body.message || 'Unknown error');
                }
            );
        }
    }
};
</script>

<style lang="less" scoped>
@import '../css/colors.less';
</style>
